import { logger } from '../logging/logger';

/**
 * GA4 `donatePlacement` values. Built-in surfaces use these directly; the staff
 * defaults apply when a staff-placed widget has no usable `data-placement`.
 */
export const DONATE_PLACEMENTS = {
  header: 'header',
  userPortal: 'user-portal',
  callCenter: 'call-center',
  upgrade: 'upgrade',
  donateBlock: 'donate-block',
  donateButton: 'donate-button',
  donationForm: 'donation-form',
} as const;

const BUILT_IN_PLACEMENTS: ReadonlySet<string> = new Set([
  DONATE_PLACEMENTS.header,
  DONATE_PLACEMENTS.userPortal,
  DONATE_PLACEMENTS.callCenter,
  DONATE_PLACEMENTS.upgrade,
]);

// GA4 truncates event parameter values longer than this.
const MAX_PLACEMENT_LENGTH = 100;

export function normalizeStaffPlacement(raw: string | null | undefined, fallback: string): string {
  const placement = (raw ?? '').trim().toLowerCase().replace(/\s+/g, '-').slice(0, MAX_PLACEMENT_LENGTH);
  if (!placement) return fallback;
  if (BUILT_IN_PLACEMENTS.has(placement)) {
    logger.warn('Donate placement is reserved for a built-in surface; using the widget default', {
      placement,
      fallback,
    });
    return fallback;
  }
  return placement;
}
